import {
  Button,
  Card,
  Skeleton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from '@mui/material';
import Plus from '@untitled-ui/icons-react/build/esm/Plus';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import DeletePopupModal from 'src/components/common-modals/delete-modal';
import { paths } from 'src/paths';
import {
  deleteSingleMdsAssessment,
  getAssessment,
  getMultipleMDAAssessment,
  getPatientDateOfService,
  resetDeleteSingleMdsAssessment,
} from 'src/redux/actions/therapyPlanning';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';
import MdsAssessmentTable from '../mdsAssessment/mds-assessment-table';
import { Permissions, usePermission } from 'src/rbac';
const { therapyPlanning } = paths;
const MDSAssessment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [message, setMessage] = useState('');
  const patientInfo = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const dispatch = useDispatch();
  const getMultipleMdsAssessment = useSelector((state: any) => state.getMultipleMDSAssessment);
  const hasUpdatePatientPermission = usePermission(Permissions.UPDATE_PATIENT);

  const [flattenedAssessments, setFlattenedAssessments] = useState<any[]>([]);

  const doesPatientHaveOpenEOC = getMultipleMdsAssessment.response
    ? getMultipleMdsAssessment.response?.data.length > 0
    : false;

  useEffect(() => {
    if (getMultipleMdsAssessment?.response?.data?.length) {
      if (location?.state?.from === 'ARD_Tab') {
        const getOpenEoc = getMultipleMdsAssessment?.response?.data?.filter(
          (mds: any) => mds?.status === 'OPENED'
        );
        const mdsAssessment = getOpenEoc?.[0]?.mdsAssessments?.filter((mds: any) => {
          if (mds?.isFinalMds) {
            return mds?.finalMds?.assessmentDate.split("T")[0] === location?.state?.ARD_Date
          }
          return mds?.assessmentDate?.split("T")[0] === location?.state?.ARD_Date
        })
        const openEocWithMds = [
          {
            ...getOpenEoc?.[0],
            mdsAssessments: mdsAssessment
          }
        ]
        
        // Flatten assessments with EOC metadata
        const flattened = openEocWithMds.flatMap((eoc: any) => 
          (eoc?.mdsAssessments || []).map((assessment: any) => ({
            ...assessment,
            episodeTitle: eoc?.episodeTitle,
            episodeStartDate: eoc?.startDate,
            episodeEndDate: eoc?.endDate,
            episodeStatus: eoc?.status,
          }))
        );
        setFlattenedAssessments(flattened);
        return
      } else {
      // Flatten all assessments from both open and closed EOCs with EOC metadata
      const allEocs = getMultipleMdsAssessment?.response?.data || [];
      const flattened = allEocs.flatMap((eoc: any) => 
        (eoc?.mdsAssessments || []).map((assessment: any) => ({
          ...assessment,
          episodeTitle: eoc?.episodeTitle,
          episodeStartDate: eoc?.startDate,
          episodeEndDate: eoc?.endDate,
          episodeStatus: eoc?.status,
        }))
      );
      setFlattenedAssessments(flattened);
    }
    } else {
      setFlattenedAssessments([]);
    }
  }, [getMultipleMdsAssessment, location?.state]);

  useEffect(() => {
    if (patientInfo) {
      if (patientInfo?.isMdsPresent)
        dispatch(
          getAssessment({
            patientId: patientInfo?.uuid,
          })
        );
      dispatch(
        getMultipleMDAAssessment({
          patientId: patientInfo?.uuid,
        })
      );
    }
  }, [patientInfo]);

  const handleEditMultipleMds = (mds: any) => {
    navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`, {
      state: {
        action: 'Edit',
        selectedPatient: patientInfo,
        assessmentDetails: mds,
        ARD_Date: location?.state?.from === 'ARD_Tab' ? location?.state?.ARD_Date : null,
        from: location?.state?.from === 'ARD_Tab' ? 'ARD_Tab' : null,
      },
    });
  };
  const [deleteMds, setDeleteMds] = useState<any>('')
  const [deleteMdsAssessment, setDeleteMdsAssessment] = useState(false)
  const handleDeleteMds = () => {
    dispatch(deleteSingleMdsAssessment({
      mdsId: deleteMds?.uuid
    }))
    setDeleteMdsAssessment(false)
  }

  const handleDeleteMultipleMds = (mds: any) => {
    setDeleteMds(mds)
    setDeleteMdsAssessment(true)
  }
  const deleteMdsAssessmentDate = useSelector((state: any) => state.deleteSingleMdsAssessmentReducer)
  useEffect(() => {
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate?.response === null
    )
      return;
    if (
      deleteMdsAssessmentDate?.isMdsAssessmentDeleted === false &&
      deleteMdsAssessmentDate !== null
    ) {
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
        setMessage('');
      }, 3000);
      return;
    } else {
      // getPerWeekNavigationAPI();
      dispatch(
        getPatientDateOfService({
          patientId: patientInfo?.uuid,
        })
      );
      dispatch(
        getMultipleMDAAssessment({
          patientId: patientInfo?.uuid,
        })
      );
      setMessage(deleteMdsAssessmentDate?.response?.message);
      setIsSnackBarOpen(true);
      setTimeout(() => {
        setMessage('');
        setIsSnackBarOpen(false);
        dispatch(resetDeleteSingleMdsAssessment());
      }, 3000);
    }
  }, [deleteMdsAssessmentDate]);


  function addNewMdsAssessment() {
    navigate(`${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.editDetails}`, {
      state: {
        action: 'Create',
        selectedPatient: patientInfo,
        ARD_Date: location?.state?.from === 'ARD_Tab' ? location?.state?.ARD_Date : null,
        from: location?.state?.from === 'ARD_Tab' ? 'ARD_Tab' : null,
      },
    });
  }

  const handleEditMds = (mds: any) => {
    handleEditMultipleMds(mds);
  };

  const handleDeleteMdsClick = (mds: any) => {
    handleDeleteMultipleMds(mds);
  };

  const handleNewAssessment = () => {
    addNewMdsAssessment();
  };

  const getTooltipMessage = useMemo(() => {
    if (!doesPatientHaveOpenEOC && !hasUpdatePatientPermission) {
      return 'An episode is required to create an MDS assessment and you do not have permission to update the patient details';
    }
    if (!doesPatientHaveOpenEOC) {
      return 'An episode is required to create an MDS assessment';
    }
    if (!hasUpdatePatientPermission) {
      return 'You do not have permission to update the patient details';
    }
    return '';
  }, [doesPatientHaveOpenEOC, hasUpdatePatientPermission]);

  const isLoading = getMultipleMdsAssessment?.loading;
  const totalAssessments = flattenedAssessments.length;
  
  // CSV Upload functionality - commented out
  // const handleUploadCsvModal = () => {
  //   setUploadCsvModal(true);
  // };
  // const handleCloseUploadCsvModal = () => {
  //   setUploadCsvModal(false);
  // };

  // const handleUploadValidationTemplate = () => {
  //   const formData = new FormData();
  //   formData.append('file', fileUploaded[0]);

  //   dispatch(getValidationCSVTemplateOfMds(formData));
  //   navigate(`/scheduling/therapy-planning/upload`);
  // };

  return (
    <Card sx={{ padding: '1.5rem' }}>
      <Stack>
        {!isLoading && (
          <>
            <Stack
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'space-between'}
            >
              <Stack
                gap="1rem"
                alignItems="center"
                flexDirection="row"
                sx={{ marginBottom: '1rem' }}
              >
                <h3 style={{ margin: '0px' }}>MDS Assessments</h3>
                {totalAssessments !== 0 && (
                  <Stack
                    flexDirection="row"
                    sx={{
                      borderRadius: '12px',
                      display: 'flex',
                      border: '1px solid #00000042',
                      color: '#111927',
                      padding: '3px 10px',
                    }}
                  >
                    <Typography variant="subtitle2">{`${totalAssessments} MDS`}</Typography>
                  </Stack>
                )}
              </Stack>
              <Stack>
                <Tooltip
                  title={getTooltipMessage}
                  followCursor
                >
                  <span>
                    <Button
                      color="inherit"
                      startIcon={
                        <SvgIcon>
                          <Plus />
                        </SvgIcon>
                      }
                      sx={{ color: 'primary.dark' }}
                      disabled={!doesPatientHaveOpenEOC || !hasUpdatePatientPermission}
                      onClick={handleNewAssessment}
                    >
                      New Assessment
                    </Button>
                  </span>
                </Tooltip>
                {/* CSV Upload Popover - commented out */}
                {/* <Popper
                  anchorEl={anchorRef.current}
                  open={popUpContent}
                  transition
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom' ? 'center top' : 'center bottom',
                        boxShadow: '0px 3px 14px 0px rgba(0, 0, 0, 0.08)',
                        borderRadius: '12px',
                        background: '#fff',
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList>
                            <MenuItem onClick={addNewMdsAssessment}>
                              <Grid container>
                                <Grid
                                  item
                                  marginRight={1}
                                >
                                  <SvgIcon
                                    sx={{
                                      color: '#6C737F',
                                    }}
                                  >
                                    <PlusIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>
                                  <Typography
                                    color={'#6C737F'}
                                    variant="subtitle2"
                                  >
                                    Add Assessment Details
                                  </Typography>
                                </Grid>
                              </Grid>
                            </MenuItem>

                            <MenuItem onClick={handleUploadCsvModal}>
                              <Grid container>
                                <Grid
                                  item
                                  marginRight={1}
                                >
                                  <SvgIcon
                                    sx={{
                                      color: '#6C737F',
                                    }}
                                  >
                                    <UploadIcon />
                                  </SvgIcon>
                                </Grid>
                                <Grid item>
                                  <Typography
                                    color={'#6C737F'}
                                    variant="subtitle2"
                                  >
                                    Upload CSV File
                                  </Typography>
                                </Grid>
                              </Grid>
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper> */}
              </Stack>
            </Stack>
          </>
        )}

        {isLoading ? (
          <>
            {Array(12)
              .fill(null)
              .map((_, index) => (
                <Skeleton key={index} />
              ))}
          </>
        ) : (
          <MdsAssessmentTable
            mdsAssessments={flattenedAssessments}
            handleEditMds={handleEditMds}
            handleDeleteMds={handleDeleteMdsClick}
            showActions={true}
            onNewAssessmentClick={handleNewAssessment}
            doesPatientHaveOpenEOC={doesPatientHaveOpenEOC}
            hasUpdatePatientPermission={hasUpdatePatientPermission}
          />
        )}
      </Stack>

      {/* CSV Upload Modal - commented out */}
      {/* <Modal
        open={uploadCsvModal}
        onClose={handleCloseUploadCsvModal}
        sx={{ p: 0 }}
      >
        <Card
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '55%',
            borderRadius: '8px',
            padding: '16px',
            maxHeight: '90%',
          }}
        >
          <CardHeader
            title="Upload MDS Assessment"
            sx={{
              padding: '16px',
              '& .MuiTypography-root': {
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: '1.5rem',
                lineHeight: 1.2,
              },
            }}
          />
          <Divider />
          <CardContent sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
            <DropzoneArea
              filesLimit={1}
              onChange={(files: any) => setFileUploaded(files)}
              dropzoneText={
                <div>
                  <p>Drag & Drop or Click To Browse</p>
                  <Button>Browse</Button>
                </div>
              }
              showFileNames={true}
              Icon={(props: any) => null}
            />
            <Stack>
              <Typography
                variant="h6"
                textAlign="center"
              >
                Enter MSD Assessment information into the template, then re-upload the file.
              </Typography>
            </Stack>
            <Stack>
              <Typography
                variant="h6"
                textAlign="center"
              >
                Maximum upload file size: 10 MB.
              </Typography>
            </Stack>
          </CardContent>
          <Stack
            flexDirection="row"
            gap="1rem"
            justifyContent="flex-end"
            sx={{ marginTop: '1rem' }}
          >
            <Button
              color="inherit"
              onClick={handleCloseUploadCsvModal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleUploadValidationTemplate}
              disabled={!fileUploaded?.[0]}
            >
              Upload
            </Button>
          </Stack>
        </Card>
      </Modal> */}

      <BootstrapDialog
        onClose={() => setDeleteMdsAssessment(false)}
        aria-labelledby="customized-dialog-title"
        open={deleteMdsAssessment}
      >
        <DeletePopupModal
          close={() => setDeleteMdsAssessment(false)}
          message="Are you sure you want to delete this MDS assessment? This action cannot be undone."
          button={{ saveLabel: 'Delete', closeLabel: 'Cancel' }}
          title="Delete MDS Assessment"
          handleSaveBtn={handleDeleteMds}
        />
      </BootstrapDialog>

      {isSnackBarOpen && message && (
        <SimpleSnackbar
          message={message}
          isError={false}
        />
      )}
    </Card>
  );
};

export default React.memo(MDSAssessment);
